import React from 'react'

import './PlaceBar.scss'

const PlaceBar = ({ onClick, children, t }) => (
    <div className="asset-manager-place-bar">
        <div className="asset-manager-place-bar__content">
            <div>{children}</div>
            <button className="button" data-size="lg" data-variant="primary" onClick={onClick}>
                {t('Place image')}
            </button>
        </div>
    </div>
)

export default PlaceBar
